import Button from '@/components/Button';
import Header from '@/components/Header';

import { useAuth } from '@/hooks/useAuth';

export default function SignInPage() {
	const { logIn } = useAuth();

	return (
		<div>
			<Header variant="h1" element="h2">Logged Out</Header>

			<p className="mb-8">Please sign in to access CPP data.</p>

			<div>
				<Button type="button" variant="primary" size="large" onClick={ logIn }>Sign In</Button>
			</div>
		</div>
	);
}